import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-message-templates',
  templateUrl: './message-templates.component.html',
  styleUrls: ['./message-templates.component.scss']
})
export class MessageTemplatesComponent implements OnInit {    
  currentUser: any;
  organizationId: string;
  databaseId:string;
  responseHolder: any;
  templateList: any; 
  value = '';
  filterText: any;
  paginatorTotalLength: any; 
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  formDialog: FormGroup;
  
  editType = {
    messageTemplateID: 0,
    subject: 0,
    message: "",   
  }
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };

  constructor(private loaderService: LoaderService, private toastr: ToastrService, private statusConst: StatusConstant,
     private reusableClass: ReusableClasses, private dialog: MatDialog, private settingsService: SettingService,
     private encryptionAlgo: EncryptionService,private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
     var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('subject',this.formBuilder.control(''));
    this.formDialog.addControl('message', this.formBuilder.control(''));
    this.getAllMessageTemplate(this.pageModelData);
  }


  openDialogWithRef(templateRef: TemplateRef<any>, type: any) {
    this.editType.messageTemplateID = type.messageTemplateID;
    this.editType.subject = type.subject;
    this.editType.message = type.message;    
    this.dialog.open(templateRef, {
    });
    this.formDialog.markAsPristine();
  }
  
  getAllMessageTemplate(pageData: any) {
    this.ShowNoRecordFound=false;
    this.loaderService.show();
    var ReqModel={
      userID: this.currentUser.UID,     
      officeID: this.myOfficeID,    
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      pageIndex : pageData.pageIndex,
      pageSize :pageData.pageSize
    }      
    this.settingsService.GetAllSubjectMessageTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.templateList = this.responseHolder.data.subjectTemplateModel;
          this.paginatorTotalLength = this.responseHolder.data.totalCount;
          this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          this.pageIndex = this.responseHolder.data.pageIndex;
          this.pageSize = pageData.pageSize;
          if(this.templateList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }    
        }
        else {
          this.ShowNoRecordFound=true;
          this.templateList=[];         
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.templateList=[];
        this.loaderService.hide();
      }
    });
  }


  deleteTemplate(temp: any) {
    var message = `Are you sure you want to delete template?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel={
          userID: this.currentUser.UID,
          messageTemplateID: temp.messageTemplateID,
          officeID: this.myOfficeID,
          organizationID: Number(this.organizationId),
          officeIDList: this.OfficeIDList
         }
        this.settingsService.DeleteSubjectMessageTemplate(ReqModel).subscribe(response => {
         if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == true) {
              this.toastr.success('Record deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getAllMessageTemplate(this.pageModelData);
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
  }


  spinner:boolean=false;

  UpdateTypeDetails() {
    this.spinner=true;
    this.formDialog.markAsPristine();
    let type = this.editType;
    this.loaderService.show();
    var ReqModel = {
      messageTemplateID: type.messageTemplateID,          
      subject: type.subject, 
      message: type.message, 
      UserID: this.currentUser.UID,
      organizationID: Number(this.organizationId),      
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList
    }
    this.settingsService.AddUpdateSubjectMessageTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.responseHolder = response;
        if (this.responseHolder.data == true) {
          this.dialog.closeAll();
          this.toastr.success('Record updated successfully.', '', {
            timeOut: 3000,
          });
          this.getAllMessageTemplate(this.pageModelData);
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue = this.value.trim();
    this.getAllMessageTemplate(this.pageModelData);
  }

  close() {
    this.dialog.closeAll();
  }
  
}